import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfiguracaoPixRoutingModule } from './configuracao-pix-routing.module';
import { ConfiguracaoPixListarComponent } from './configuracao-pix-listar/configuracao-pix-listar.component';
import { ConfiguracaoPixInserirComponent } from './configuracao-pix-inserir/configuracao-pix-inserir.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfiguracaoPixDetalharComponent } from './configuracao-pix-detalhar/configuracao-pix-detalhar.component';
import { ConfiguracaoPixEditarComponent } from './configuracao-pix-editar/configuracao-pix-editar.component';


@NgModule({
  declarations: [
    ConfiguracaoPixListarComponent,
    ConfiguracaoPixInserirComponent,
    ConfiguracaoPixDetalharComponent,
    ConfiguracaoPixEditarComponent
  ],
  imports: [
    CommonModule,
    ConfiguracaoPixRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    MessagesModule,
    ConfirmDialogModule,
    ProgressSpinnerModule
  ],
  providers: [ConfirmationService]
})
export class ConfiguracaoPixModule { }
